<template>
  <div
    :style="{ 'min-height': `${contentHeight}px` }"
    :class="{ empty: !listDoc || !listDoc.length }"
  >
    <div class="d-flex align-items-center mb-2">
      <h6 class="mb-0 mr-4">{{ $l('form_label_orderDoc') || '订单文件' }}</h6>
      <el-button v-if="!disabled" size="mini" @click="uploadFile">
        {{ $l('btn_uploadDoc') || '上传文件' }}
      </el-button>
    </div>

    <div class="row" v-if="listDoc && listDoc.length">
      <div
        v-for="doc in listDoc"
        :key="doc.evgBulkOrderDocCode"
        class="col-md-6 col-xl-4 mt-3"
      >
        <el-card shadow="never" class="doc-card">
          <div class="doc-card-header text-truncate">
            Modify by：{{ doc.uploadByName }} at {{ doc.uploadTime }}
          </div>
          <div class="doc-card-body">
            <div class="doc-type-icon d-flex">
              <el-avatar
                shape="square"
                class="bg-transparent"
                :src="doc.fileTypeIcon"
              />
            </div>
            <div class="doc-info">
              <div class="doc-name">{{ doc.fileName }}</div>
              <div class="d-flex justify-content-end">
                <span v-if="!disabled">
                  <i
                    class="el-icon-delete tool-btn"
                    style="color: #FA5C7C;"
                    @click="del(doc)"
                  />
                </span>
                <span>
                  <i class="el-icon-view tool-btn" @click="view(doc)" />
                </span>
                <span>
                  <i class="el-icon-download tool-btn" @click="download(doc)" />
                </span>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div
      v-else
      style="flex-grow: 1;"
      class="d-flex align-items-center justify-content-center"
    >
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { VXETable } from 'vxe-table'
import { request } from '@/api/service'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    evgBulkOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { listDoc: [], fileIcons: {} }
  },
  computed: {
    contentHeight() {
      return window.innerHeight - 400
    },
  },
  mounted() {
    this.getData()
    this.getFileIcons()
  },
  methods: {
    async getData() {
      if (!this.evgBulkOrderCode) return
      const res = await this.$api
        .ecomEvgBulkOrderDocListApi({ evgBulkOrderCode: this.evgBulkOrderCode })
        .catch(() => null)
      const data = res?.body?.data || []

      this.listDoc = data.map((item) => {
        const fileTypeIcon = this.getFileIcon(item.fileName)
        return { ...item, fileTypeIcon }
      })
    },
    async getFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    getFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }

      const fileType = getFileType(fileName) || 'OTHER'
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    async uploadFile() {
      const { files } = await VXETable.readFile({
        multiple: true,
      }).catch(() => ({}))

      const uploadTask = Array.from(files).map((item) =>
        this.$api
          .SYS_UPLOAD(item)
          .then((res) => ({
            fileName: item.name,
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
          }))
          .catch(() => null)
      )

      if (this.loadingOpen()) return
      const listDoc = await Promise.all(uploadTask)
      if (listDoc.includes(null)) {
        this.$message.warning(
          this.$l('tips_warning_upload_doc_error') ||
            '文件上传失败，请联系管理员'
        )
        this.loadingClose()
        return
      }

      const params = { evgBulkOrderCode: this.evgBulkOrderCode, listDoc }
      const res = await this.$api
        .ecomEvgBulkOrderDocUploadApi(params)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.uploader_label_status_error'))
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success'),
        type: 'success',
      })
      this.getData()
    },
    async del({ evgBulkOrderDocCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_deleteDoc') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomEvgBulkOrderDocDelApi({ evgBulkOrderDocCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
    },
    view({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode, { isAutoDown: true, preview: true })
    },
    download({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
  },
}
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  flex-direction: column;
}

::v-deep {
  .doc-card .el-card__body {
    padding: 0;
    font-size: 14px;
  }

  .el-avatar {
    width: 80px;
    height: 80px;
  }
}

.doc-card-header {
  background-color: #fafafa;
  color: #6c757d;
  line-height: 40px;
  padding: 0 14px;
}
.doc-card-body {
  padding: 8px 14px;
  display: flex;
  flex-direction: row;
  .doc-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    .doc-name {
      flex-grow: 1;
      word-break: break-all;
    }
  }
}
.no-data {
  color: #606266;
  font-size: 13px;
}
</style>
